import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  AskMeAnythingSummaryLoadAction,
  AskMeAnythingSummaryUpdateFulfilledAction,
} from '../../domains/askMeAnythingSummaries/actions.types';

type AskMeAnythingSummaryAction = AskMeAnythingSummaryLoadAction | AskMeAnythingSummaryUpdateFulfilledAction;

import { AskMeAnythingSummaries } from './types';

const initialState: AskMeAnythingSummaries = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<AskMeAnythingSummaries, AskMeAnythingSummaryAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ASK_ME_ANYTHING_SUMMARY.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.askMeAnythingSummaries);
    case 'ASK_ME_ANYTHING_SUMMARY.UPDATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.askMeAnythingSummaries);
    case 'ASK_ME_ANYTHING_SUMMARY.LOAD_PENDING':
      return moveToPending(state, [action.payload.teamsMeetingId]);
    case 'ASK_ME_ANYTHING_SUMMARY.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.teamsMeetingId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
